<template>
  <div class="left-bottom-list">
    <div :class="['flex-just']" style="position: relative">
      <div class="tilte-list">
        <img :src="require('@/assets/daping/title-long-mini.svg')" class="title-long" />
        <div
          :class="[!isShowAll ? 'changqixuncha' : 'title-name']"
          @click="changqixunchaClick"
        >
          长期巡查趋势
        </div>
      </div>
      <div
        :class="[!isShowAll ? 'gugualaorenCheck' : 'gugualaoren']"
        @click="gugualaorenClick"
      >
        孤寡老人巡查趋势
      </div>
      <!-- <titleComponent titleName="孤寡老人巡查趋势"> </titleComponent> -->
    </div>
    <div class="flex-just">
      <div class="center-point" v-if="isShowAll">
        <div style="width: 727px; height: 280px">
          <wgEchart :options="leftBottomOneList" id="leftBottomOne"></wgEchart>
        </div>
      </div>
      <div class="center-point" v-else>
        <div style="width: 727px; height: 280px">
          <wgEchart :options="leftBottomTwoList" id="leftBottomTwo"></wgEchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleComponent from "@/pages/patrolScreenMini/components/title.vue";
import { getLongPatrolMouth, getOldPeopleMouth } from "@/api/daping.js";
import * as echarts from "echarts";

export default {
  name: "index",
  components: {
    wgEchart,
    titleComponent,
  },
  data() {
    return {
      leftBottomOneList: {},
      leftBottomTwoList: {},
      isShowAll: true,
    };
  },
  mounted() {
    this.getLongPatrolMouth();
    this.getOldPeopleMouth();
  },
  methods: {
    async getLongPatrolMouth() {
      let res = await getLongPatrolMouth();
      if (res.data.code == 200) {
        this.optionsListData(res.data.data && res.data.data.longPatrolTrendMouthList);
      }
    },
    async getOldPeopleMouth() {
      let res = await getOldPeopleMouth();
      if (res.data.code == 200) {
        this.optionsListDataTwo(res.data.data && res.data.data.oldPersonTrendMouthList);
      }
    },
    optionsListData(dataList) {
      let dataTime = dataList.map((item) => item.yearMouth).reverse();
      let data2 = dataList.map((item) => item.completeCount).reverse();
      let data3 = dataList.map((item) => item.shangbaoCount).reverse();
      let data1 = dataList.map((item) => item.taskCount).reverse();
      this.leftBottomOneList = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
          formatter: function (param) {
            let res = param[0].name + "<br>";
            for (let j = 0; j < param.length; j++) {
              // 渐变色导致提示框中颜色消失,额外定义
              let marker = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${param[j].color.colorStops[1].color};"></span>`;
              res += marker + param[j].seriesName + ": " + param[j].value + "<br>";
            }
            return res;
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          top: "14%",
          bottom: "4%",
          containLabel: true,
        },
        legend: {
          data: ["总任务数", "巡查记录数", "上报问题数"],
          right: 10,
          top: 10,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 12,
          },
          itemWidth: 14,
          itemHeight: 7,
          // itemGap: 35
        },
        xAxis: {
          type: "category",
          data: dataTime,
          axisLine: {
            lineStyle: {
              color: "#8c9493",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 40,
            textStyle: {
              fontSize: 14,
              color: "#ADC2D3",
            },
          },
        },

        yAxis: {
          name: "单位：个",
          nameTextStyle: {
            color: "#ADC2D3",
            fontSize: 12,
          },
          type: "value",
          // max: "150",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#8c9493",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(172, 206, 234, 0.2)",
              type: "dashed",
            },
          },
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: "#ADC2D3",
            },
          },
        },
        series: [
          // {
          //   name: "总任务数",
          //   type: "bar",
          //   barWidth: 6,
          //   itemStyle: {
          //     color: {
          //       type: "linear",
          //       x: 0,
          //       y: 1,
          //       x2: 0,
          //       y2: 0,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "rgba(0,255,239,0)", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#00FFEF", // 100% 处的颜色
          //         },
          //       ],
          //       globalCoord: false, // 缺省为 false
          //     }, //底色
          //   },
          //   data: data1,
          // },
          // {
          //   name: "巡查记录数",
          //   type: "bar",
          //   barWidth: 6,
          //   itemStyle: {
          //     color: {
          //       type: "linear",
          //       x: 0,
          //       y: 1,
          //       x2: 0,
          //       y2: 0,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "rgba(0,163,255,0)", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#00A3FF", // 100% 处的颜色
          //         },
          //       ],
          //       globalCoord: false, // 缺省为 false
          //     }, //底色
          //   },
          //   data: data2,
          // },
          {
            name: "上报问题数",
            type: "line",
            barWidth: 6,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(247,180,103,0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#F7B467", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              }, //底色
            },
            data: data3,
          },
        ],
      };
    },
    optionsListDataTwo(dataList) {
      let dataTime = dataList.map((item) => item.yearMouth)
      let data1 = dataList.map((item) => item.taskCount);
      let data2 = dataList.map((item) => item.completeCount);
      let data3 = dataList.map((item) => item.xunchaFrequency);
      this.leftBottomTwoList = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
          // formatter: function (param) {
          //   let res = param[0].name + "<br>";
          //   for (let j = 0; j < param.length; j++) {
          //     // 渐变色导致提示框中颜色消失,额外定义
          //     let marker = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${param[j].color.colorStops[1].color};"></span>`;
          //     res += marker + param[j].seriesName + ": " + param[j].value + "<br>";
          //   }
          //   return res;
          // },
        },
        grid: {
          left: "4%",
          right: "4%",
          top: "20%",
          bottom: "10%",
          containLabel: true,
        },
        legend: {
          data: ["总巡查数", "已巡查数"],
          right: 20,
          top: 20,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 12,
          },
          itemWidth: 14,
          itemHeight: 7,
          // itemGap: 35
        },
        xAxis: {
          type: "category",
          data: dataTime,
          axisLine: {
            lineStyle: {
              color: "#8c9493",
            },
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              fontSize: 12,
              color: "#ADC2D3",
            },
            //多出字可以省略显示成点
            formatter: function (params) {
              var index = 10; //字数为6个超出就显示成点
              var newstr = "";
              for (var i = 0; i < params.length; i += index) {
                var tmp = params.substring(i, i + index);
                newstr += tmp + "";
              }
              if (newstr.length > 10) return newstr.substring(0, 10) + "...";
              else return "\n" + newstr;
            },
          },
        },
        dataZoom: [
          {
            // 设置滚动条的隐藏与显示
            show: dataTime.length > 6,
            // 设置滚动条类型
            type: "slider",
            // 设置背景颜色
            backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 5,
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 设置滚动条宽度，相对于盒子宽度
            width: "90%",
            // 设置滚动条高度
            height: 8,
            // 设置滚动条显示位置
            left: "center",
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 控制手柄的尺寸
            handleSize: 0,
            // dataZoom-slider组件离容器下侧的距离
            bottom: 3,
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标滚轮触发滚动
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        yAxis: [
          {
            name: "单位：个",
            nameTextStyle: {
              color: "#ADC2D3",
              fontSize: 12,
            },
            type: "value",
            // max: "150",
            position: "left",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#8c9493",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(172, 206, 234, 0.2)",
                type: "dashed",
              },
            },
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: "#ADC2D3",
              },
            },
          },
          // {
          //   type: "value",
          //   name: "单位：次",
          //   formatter: "{value} %",
          //   show: true,
          //   min: 0,
          //   max: 100,
          //   interval: 20,
          //   nameTextStyle: {
          //     color: "#ADC2D3",
          //     fontSize: 12,
          //   },
          //   splitLine: {
          //     show: false,
          //     lineStyle: {
          //       color: "rgba(172, 206, 234, 0.2)",
          //       type: "dashed",
          //     },
          //   },
          //   axisLabel: {
          //     show: true,
          //     textStyle: {
          //       color: "#ADC2D3",
          //       fontSize: 12,
          //     },
          //   },
          //   axisLine: {
          //     show: false,
          //   },
          //   axisTick: {
          //     show: false,
          //   },
          // },
        ],
        series: [
          {
            name: "总巡查数",
            type: "bar",
            barWidth: 6,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00FFEF" },
                { offset: 1, color: "rgba(0,255,239,0.1)" },
              ]),
            },
            data: data1,
          },
          {
            name: "已巡查数",
            type: "bar",
            barWidth: 6,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00A3FF" },
                { offset: 1, color: "rgba(0,163,255,0.1)" },
              ]),
            },
            data: data2,
          },
          // {
          //   name: "巡查频率",
          //   type: "line",
          //   smooth: false, //平滑曲线显示
          //   // symbol: 'circle', //标记的图形为实心圆
          //   symbolSize: 6, //标记的大小
          //   itemStyle: {
          //     normal: {
          //       color: "#F7B467",
          //     },
          //   },
          //   lineStyle: {
          //     normal: {
          //       width: 1,
          //     },
          //   },
          //   data: data3,
          // },
        ],
      };
    },
    gugualaorenClick() {
      this.isShowAll = false;
    },
    changqixunchaClick() {
      this.isShowAll = true;
    },
  },
};
</script>
<style scoped lang="less">
.left-bottom-list {
  width: 100%;
}
.flex-just {
  display: flex;
  justify-content: space-between;
}

.center-point {
  width: 727px;
  height: 285px;
  background: linear-gradient(0, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  margin-top: 8px;
}
.tilte-list {
  position: relative;
  .title-long {
    width: 727px;
  }
  .title-short {
    width: 732px;
  }
  .title-name {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 27px;
    color: #f3f8ff;
    line-height: 37px;
    text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);
    text-align: left;
    font-style: normal;
    background: linear-gradient(180deg, #ffffff 0%, #5bacef 100%);
    color: transparent;
    /* 使用背景渐变填充文字 */
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);

    position: absolute;
    left: 50px;
    top: 12px;
  }
  .changqixuncha {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 27px;
    color: #f3f8ff;
    line-height: 37px;
    text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);
    text-align: left;
    font-style: normal;
    background: linear-gradient(
        180deg,
        rgba(0, 163, 255, 0.5) 0%,
        rgba(0, 208, 255, 0) 100%
      ),
      radial-gradient(
        1115% 100% at 0% 0%,
        rgba(0, 163, 255, 0.3) 0%,
        rgba(0, 208, 255, 0) 100%
      );
    // backdrop-filter: blur(3.047619047619047px);
    color: transparent;
    /* 使用背景渐变填充文字 */
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);
    position: absolute;
    left: 50px;
    top: 12px;
  }
}
.gugualaoren {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 27px;
  color: #f3f8ff;
  line-height: 37px;
  text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);
  text-align: left;
  font-style: normal;
  background: linear-gradient(
      180deg,
      rgba(0, 163, 255, 0.5) 0%,
      rgba(0, 208, 255, 0) 100%
    ),
    radial-gradient(
      1115% 100% at 0% 0%,
      rgba(0, 163, 255, 0.3) 0%,
      rgba(0, 208, 255, 0) 100%
    );
  // backdrop-filter: blur(3.047619047619047px);
  color: transparent;
  /* 使用背景渐变填充文字 */
  -webkit-background-clip: text;
  background-clip: text;
  text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);

  position: absolute;
  left: 236px;
  top: 12px;
}

.gugualaorenCheck {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 27px;
  color: #f3f8ff;
  line-height: 37px;
  text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);
  text-align: left;
  font-style: normal;
  background: linear-gradient(180deg, #ffffff 0%, #5bacef 100%);
  color: transparent;
  /* 使用背景渐变填充文字 */
  -webkit-background-clip: text;
  background-clip: text;
  text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);

  position: absolute;
  left: 236px;
  top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/left/left-bottom.vue